import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Book18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.5 0.25C3.2745 0.25 2.25 1.2745 2.25 2.5V15.5C2.25 16.7255 3.2745 17.75 4.5 17.75H15C15.4142 17.75 15.75 17.4142 15.75 17V4C15.75 3.58579 15.4142 3.25 15 3.25H4.5C4.10217 3.25 3.75 2.89783 3.75 2.5C3.75 2.10217 4.10217 1.75 4.5 1.75H15V0.25H4.5ZM3.75 15.5V4.62132C3.98865 4.7057 4.24204 4.75 4.5 4.75H10V9L11 8L12 9V4.75H14.25V16.25H4.5C4.10218 16.25 3.75 15.8978 3.75 15.5Z'
      fill='currentColor'
    />
  </Svg>
);

Book18.displayName = 'Book18';
export default Book18;
